import { usePairMarketScheduleStore } from '@ui/features/RWA/hooks/usePairMarketScheduleStore/usePairMarketScheduleStore';
import { useDataChainId } from '@ui/hooks/datachain';
import { PairsV4 } from '@ui/services/contract/hooks/PairsManagerFacet/usePairsV4';
import { BareTradePair } from '@ui/types/tradePair';
import { createContext, ReactNode, useContext, useMemo } from 'react';

import { useTradePairInfos } from '../../../../hooks/trade/useTradePairInfos';

type OrderListContextValue = {
  feeConfig?: PairsV4['feeConfig'];
  isMarketHourOpen: boolean;
};

const OrderListContext = createContext<OrderListContextValue>({
  isMarketHourOpen: true,
});

export const OrderListContextProvider = ({
  children,
  pair,
}: {
  children: ReactNode;
  pair: BareTradePair;
}) => {
  const pairs = useTradePairInfos();
  const chainId = useDataChainId();
  const isOpen = usePairMarketScheduleStore(
    (s) => s.getMarketScheduleByPair(pair.pairName, chainId).isClientOpen,
  );
  const context = useMemo(
    () => ({
      feeConfig: pairs?.find(
        (p) => p.base.toLowerCase() === pair.address.toLowerCase(),
      )?.feeConfig,
      isMarketHourOpen: isOpen,
    }),
    [isOpen, pair.address, pairs],
  );

  return (
    <OrderListContext.Provider value={context}>
      {children}
    </OrderListContext.Provider>
  );
};

export const useOrderListContext = () => useContext(OrderListContext);
